import { useAppDispatch } from 'hooks/redux';
import * as React from 'react';
import { useCallback, useEffect } from 'react';

import { Typography } from '@mui/material';
// COMPONENTS
import StdDialog from 'components/Dialogs/StdDialog';
import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';

import { achievementsActions } from 'app-components/flux/achievements';
import { freeToSpendTypes } from 'app-components/flux/free-to-spend';
import { usePreferenceV2 } from 'app-components/flux/preferences-v2';
import { rootUiActions } from 'app-components/flux/root-ui';
// APP-COMPONENTS
import { tracker } from 'app-components/utils/core';
import OtherSpending from 'assets/images/spendingPlan/OtherSpending.svg';
import SimpleContentView from '../SimpleContentView';

const { GSFStageEnum } = freeToSpendTypes;

function Other() {
  const [_gettingStartedFlowPhase, setGettingStartedFlowPhase] = usePreferenceV2(
    'sSPGettingStartedFlowPhase',
    GSFStageEnum.COMPLETE,
  );
  const dispatch = useAppDispatch();

  const onClose = useCallback(() => {
    dispatch(achievementsActions.sendAchievementsEvent({ source: 'SPENDING_PLAN', eventType: 'CREATE' }));
    tracker.track(tracker.events.completeSpendingPlanSetup);
    setGettingStartedFlowPhase(GSFStageEnum.COMPLETE);
    dispatch(rootUiActions.removeDialog());
  }, [dispatch, setGettingStartedFlowPhase]);

  useEffect(() => {
    tracker.track(tracker.events.viewOtherSpendIntro);
  }, []); // eslint-disable react-hooks/exhaustive-deps

  return (
    <StdDialog
      onClose={onClose}
      open={true}
      sharedcomponentid={'FIRST_TIME_USE_DIALOG_V2'}
      showCloseButton
      size='md'
      title={''}
    >
      <StdDialogContent
        id='spending_plan_other_dialog'
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <SimpleContentView
          image={<img src={OtherSpending} width='128px' height='128px' />}
          mainText={'Track your Other Spend'}
          secondaryText={
            <Typography variant='bodyRegular' color={'textSecondary'}>
              All other spend not tracked as&nbsp;
              <Typography component='span' variant='bodyMedium'>
                Bills
              </Typography>{' '}
              or&nbsp;
              <Typography component='span' variant='bodyMedium'>
                Planned Spend
              </Typography>{' '}
              will appear in&nbsp;
              <Typography component='span' variant='bodyMedium'>
                Other Spend
              </Typography>
              . Easily see where the rest of your money is spent each month.
            </Typography>
          }
        />
      </StdDialogContent>
      <StdDialogActions
        primary={{
          id: 'primary-button',
          children: 'Got it',
          onClick: onClose,
          variant: 'contained',
        }}
      />
    </StdDialog>
  );
}

export default Other;
